// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/images/Image_1920x300.webp");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "#fallback[data-v-f74ced4c]{pointer-events:none;background-color:#d3d3d3}.backgroundColor[data-v-f74ced4c]{background-color:#f8f9fa}.homeBanner[data-v-f74ced4c]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");color:#fff;padding:3rem!important}#trust-us-card[data-v-f74ced4c]{background-repeat:no-repeat;min-height:250px;border-bottom:0;border-color:#fff}.content[data-v-f74ced4c]{padding-top:38px}", ""]);
// Exports
module.exports = exports;
